import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ValueProps } from '../components/ValueProps';
import { FamilyCaregiverSection } from '../components/FamilyCaregiverSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <main data-id="element-354">
      <HeroSection data-id="element-355" />
      <ValueProps data-id="element-356" />
      <FamilyCaregiverSection data-id="element-357" />
      <TestimonialsSection data-id="element-358" />
      <CTABanner data-id="element-359" />
    </main>;
}